import permissions from 'api/Apollo/permissions';
import useQuery from 'api/hooks/useQuery';

import { GET_SAMPLE_EVENTS } from './sample-events-query-builder';

export default function useQuerySampleEvents({ ...options } = {}) {
  const { data, loading, isAllowed, error, ...rest } = useQuery(GET_SAMPLE_EVENTS, {
    context: { permission: permissions.readSampleEvents },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    ...options,
  });

  return { data: data?.sampleEvents || [], loading, isAllowed, error, ...rest };
}
